var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowSide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.9 32.2",
    style: {
      enableBackground: "new 0 0 18.9 32.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#3A4452;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.3,31.3c0.7-0.9,0.5-2.1-0.3-2.8L6.1,19.2c-1.1-0.8-1.7-1.9-1.7-3c0,0,0-0.1,0-0.1c0,0,0-0.1,0-0.1 c0-1.1,0.6-2.2,1.7-3L18,3.7c0.9-0.7,1-1.9,0.3-2.8c-0.7-0.9-1.9-1-2.8-0.3L3.7,9.8c-2.1,1.6-3.2,3.8-3.2,6.2c0,0,0,0,0,0 c0,0,0,0,0,0c0,2.4,1.1,4.6,3.2,6.2l11.9,9.3C16.4,32.3,17.6,32.1,18.3,31.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSide);
export default __webpack_public_path__ + "static/media/arrow-side.b063525992f5469cf09daa4acf8dfd5b.svg";
export { ForwardRef as ReactComponent };